import React from 'react'
import { DistributoreNode } from '@gql/graphql-get'
import { ListingHead, Page, StoreLocatorInternational } from 'components/organisms'
import styles from './StoreLocatorInternationalTemplate.module.sass'

interface Props {
  pagina?: any
  distributori?: DistributoreNode[]
}

const StoreLocatorInternationalTemplate = (props: Props) => {
  const { pagina = {}, distributori = [] } = props

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <ListingHead pagina={pagina} />
      <main className={styles.layout}>
        <StoreLocatorInternational distributori={distributori} />
      </main>
    </Page>
  )
}

export default StoreLocatorInternationalTemplate
